import { PureComponent, PropsWithChildren } from "react";

export default class CurrencyPaneEditorValue extends PureComponent<PropsWithChildren> {
  render() {
    return (
      <div className="ct-currency-pane__editor-value">
        {this.props.children}
      </div>
    );
  }
}
